import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  Modal,
  Box,
  Button,
  Text,
  Select,
} from '@rsos/components/capstone/base';
import {
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@rsos/components/capstone/base/Modal/ModalComponents';
import InputText from '@rsos/components/capstone/base/form/inputs/InputText';
import { updateAppUser } from '@rsos/sinatra';
import { notifySuccess, notifyError } from '@rsos/utils/toastUtils';
import { GENERIC_REQUEST_ERROR_MESSAGE } from '../../../constants/defaultErrorMessages';
import { trackEditUserSuccess } from '../usersTrackings';
import { Label, ButtonContainer } from './Modal.styles';

const EditUserModal = ({
  user,
  orgID,
  allRoles,
  isOpened,
  application,
  toggleEditUserModal,
}) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRole, setSelectedRole] = useState(user.role);

  const buildOptions = state => ({
    label: state.name,
    value: state.name,
  });

  const editUser = (updatedRole, user) => {
    const newUser = {
      ...user,
      role: updatedRole.role || user.role,
    };
    dispatch(updateAppUser(orgID, application, newUser))
      .then(() => {
        trackEditUserSuccess();
        notifySuccess('Role assigned.');
      })
      .catch(action => {
        const errorMessage = action?.error?.message;
        notifyError(
          errorMessage ? errorMessage : GENERIC_REQUEST_ERROR_MESSAGE,
        );
      })
      .finally(() => {
        setIsLoading(false);
        toggleEditUserModal();
      });
  };

  const updateUser = () => {
    if (user.role !== selectedRole) {
      setIsLoading(true);
      let updatedRole = {
        role: selectedRole,
      };
      editUser(updatedRole, user);
    }
  };

  const handleRoleChange = selectedOption => {
    setSelectedRole(selectedOption.value);
  };

  return (
    <Modal
      id="edit-user-modal"
      isOpened={isOpened}
      onClose={toggleEditUserModal}
      width={404}
    >
      <ModalHeader onClose={toggleEditUserModal}>
        <Box mx="5px">
          <Text size="xlarge" color="secondaryText">
            Edit User
          </Text>
        </Box>
      </ModalHeader>

      <ModalBody pt="19px" justify="center" noFooter>
        <Box mx="5px">
          <Box pb={4}>
            <Label isDisabled>
              <Text>Name</Text>
            </Label>
            <InputText
              type="text"
              isDisabled
              readOnly
              placeholder={`${user.first_name} ${user.last_name}`}
            />
          </Box>
          <Box pb={'27px'}>
            <Label>
              <Text>Role</Text>
            </Label>
            <Select
              options={allRoles.map(buildOptions)}
              placeholder={selectedRole}
              isClearable={false}
              isSearchable={false}
              onChange={selectedOption => {
                handleRoleChange(selectedOption);
              }}
              value={selectedRole}
            />
          </Box>
        </Box>
      </ModalBody>
      <ModalFooter justify="center">
        <ButtonContainer horizontal>
          <Button grow btnType="tertiary" onClick={toggleEditUserModal}>
            Cancel
          </Button>
          <Button
            disabled={isLoading}
            grow
            btnType="primary"
            onClick={updateUser}
          >
            Save
          </Button>
        </ButtonContainer>
      </ModalFooter>
    </Modal>
  );
};

export default EditUserModal;
